import { createApp } from 'vue';
import '@/css/tailwind.css';
import '@/css/zstyle.css';
import App from './App.vue';
import router from './router';
import { Vue3Mq } from 'vue3-mq';
import {appInit} from '@projectRoot/inits';
import zCurrency from '@/directives/currency';
import zettantCurrency from '@/directives/zCurrency';
import columnResizable from '@/directives/columnResizable';

const app = createApp(App);
app.use(router);  // vue-routerを使う。mountより前にuseしなければならない
app.use(Vue3Mq, {
  preset: 'tailwind',  // tailwindと同じブレークポイント設定を使う
});
appInit(app);  // zettant独自の初期化処理を実行する
app.directive('currency', zCurrency);  // zettant独自のdirectiveを登録する
app.directive('z-currency', zettantCurrency);  // zettant独自のdirectiveを登録する
app.directive('z-column-resizable', columnResizable);  // zettant独自のdirectiveを登録する

app.mount('#app');
